<template>

    <div class="page__main container">
        <div class="page__index block-index">
            <div class="catalog">
                <div class="catalog__head">
                    <div class="fast-pay__form fast-pay-form block-left">
                        <div class="fast-pay__tabs-inner">
                            <ul class="subnav subnav--fast-pay">
                                <li class="subnav__item active">
                                    <a href="#fastPayInner_1" class="subnav__link link h4" data-toggle="tab" @click="listAcc=[]">Укажите лицевой счет</a>
                                </li>
                                <li class="subnav__item">
                                    <a href="#fastPayInner_2" class="subnav__link  link h4" data-toggle="tab" @click="listAcc=[]">Укажите адрес</a>
                                </li>
                            </ul>
                            <a href="#" class="fast-pay__lk-link link link--pseudo-rev" data-drop-toggle="modalLogin">
                                <span class="link__text">Войти в личный кабинет</span>
                            </a>
                        </div>
                        <div id="fastPayInner_1" class="fast-pay-form__inner active">
                            <div class="fast-pay-form__inner-block js-form">
                                <div class="fast-pay-form__col fast-pay-form__col--laptop-quarter">
                                    <div class="b-select fast-pay__lg-select city-select city-select--faq">
                                        <div class="city-select__label">Город *</div>
                                        <select class="b-select__picker selectpicker" data-style="null" data-style-base="button" v-bind:title="(selectedCity == '')?'Выберите город':selectedCity.Name" v-model="cityId">
                                            <option v-for="city in Cities" v-if="city.BspIds || city.DivisionIds" v-bind:value="city.Id">{{ city.Name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="fast-pay-form__col fast-pay-form__col--laptop-quarter">
                                    <label class="txt-input">
                                        <div class="city-select__label">Лицевой счёт</div>
                                        <div class="txt-input__input">
                                            <input v-if="isVisibleAcc" class="txt-input__field input js-count-pay req" v-bind:style="(errFind) ? 'borderColor: red' : 'borderColor: black'" type="number" @keyup="maxLen()" v-model="accInput" @click="errFind=false;">
                                            <input v-else class="txt-input__field input js-count-pay req" style="border-color: black" disabled="disabled">
                                        </div>
                                    </label>
                                </div>
                                <div class="fast-pay-form__col fast-pay-form__col--right" v-on:click="Find">
                                    <a id="key-find-account" href="" v-bind:class="btClass" data-submit>
                                        <span class="button__text">Поиск</span>
                                    </a>
                                </div>
                            </div>
                            <div class="alert alert--info">
                                Если Вы не нашли Ваш населённый пункт в списке, то выберите ближайший к Вам населенный пункт
                                <div v-if="(error.length>0) | errorPhone | errorEmail" style="color: red;">
                                    {{error}}
                                    <span v-if="errorEmail" style="color: red;">Неверно указан адрес Email. </span>
                                    <span v-if="errorPhone" style="color: red;">Неверно указан номер телефона.</span>
                                </div>
                            </div>
                        </div>
                        <div id="fastPayInner_2" class="fast-pay-form__inner">
                            <div class="fast-pay-form__inner-block">

                                <div class="fast-pay-form__col fast-pay-form__col--laptop-quarter">
                                    <div class="b-select fast-pay__lg-select city-select city-select--faq">
                                        <div class="city-select__label">Город *</div>
                                        <select class="b-select__picker selectpicker" data-style="null" data-style-base="button" title="Выберите город" v-model="cityIdx">
                                            <option v-for="(city,index) in CitiesFl" v-if="city.BspId" v-bind:value="index">{{ city.City }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="fast-pay-form__col fast-pay-form__col--laptop-quarter">
                                    <div class="b-select">
                                        <div class="city-select__label">Улица</div>
                                        <div id="streets-div">
                                            <select class="b-select__picker selectpicker"
                                                    data-style-base="button"
                                                    data-live-search="true"
                                                    v-on:change="changeItemStreet()"
                                                    id="streets" data-size="7">
                                                <option disabled>Нет улиц для выбора</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="fast-pay-form__col fast-pay-form__col--auto">
                                    <div class="b-select">
                                        <div class="city-select__label">Дом *</div>
                                        <div id="houses-div">
                                            <select class="b-select__picker selectpicker"
                                                    data-style-base="button"
                                                    data-live-search="true"
                                                    v-on:change="changeItemHouse()"
                                                    data-none-selected-text="Ничего не выбрано"
                                                    id="houses" data-size="7">
                                            </select>
                                        </div>

                                    </div>
                                </div>
                                <div class="fast-pay-form__col fast-pay-form__col--auto">
                                    <div class="b-select">
                                        <div class="city-select__label">Квартира</div>
                                        <div id="flats-div">
                                            <select class="b-select__picker selectpicker"
                                                    data-style-base="button"
                                                    data-live-search="true"
                                                    v-on:change="changeItemFlat()"
                                                    data-none-selected-text="Ничего не выбрано"
                                                    id="flats" data-size="7">
                                            </select>
                                        </div>

                                    </div>
                                </div>
                                <div class="fast-pay-form__col fast-pay-form__col--right" v-on:click="getAccountByAddr()">
                                    <a href="" v-bind:class="btClassFl">
                                        <span class="button__text">Поиск</span>
                                    </a>
                                </div>
                            </div>
                            <div class="alert alert--info">
                                Поиск по адресу доступен только для физических лиц
                                <div v-if="(error.length>0) | errorPhone | errorEmail" style="color: red;">
                                    {{error}}
                                    <span v-if="errorEmail" style="color: red;">Неверно указан адрес Email. </span>
                                    <span v-if="errorPhone" style="color: red;">Неверно указан номер телефона.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="catalog__body">
                    <div v-if="listAcc.length>0" class="catalog__list block-left" data-catalog-list>
                        <div id="questionForm" class="fast-pay js-ajax-form">
                            <div class="fast-pay__location form-list">
                                <account v-for="(acc, index) in listAcc" :acc=acc :index=index :cnt=listAcc.length :indexAcc=indexAcc @updateIndex="updateIndex" @updateSum="updateSum" ref="acc" />
                            </div>
                            <div v-if="isTax" class="fast-pay__caption">
                                <div class="alert alert--info">Внимание: при оплате услуг с использованием банковсвкой карты дополнительно взымается комиссия – 1% (один процент)</div>
                            </div>
                            <!--<div class="fast-pay__caption">
                                <div v-if="(error.length>0) | errorPhone | errorEmail" class="alert alert--info" style="color: red;">
                                    {{error}}
                                    <span v-if="errorEmail">Неверно указан адрес Email. </span>
                                    <span v-if="errorPhone">Неверно указан номер телефона.</span>
                                </div>
                            </div>-->

                            <div class="fast-pay__footer">
                                <div class="fast-pay-submit fast-pay-submit--flex">
                                    <div class="fast-pay-submit__left-section">
                                        <div class="txt-input__label">Способ доставки электронного кассового чека</div>
                                        <div class="fast-pay-submit__row">
                                            <div class="fast-pay-form__col line-form__double-btn-width">
                                                <label class="txt-input">
                                                    <div class="txt-input__input">
                                                        <input v-model="email" class="txt-input__field input" type="mail" placeholder="info@mail.ru" data-type="email"
                                                               @mouseout="testEmail()">
                                                        <div class="txt-input__required txt-input__required--error">Неверно указан адрес Email</div>
                                                    </div>
                                                </label>
                                            </div>
                                            <div class="fast-pay-form__col line-form__double-btn-width">
                                                <label class="txt-input">
                                                    <div class="txt-input__input">
                                                        <input id="phone-user" value="+7 "
                                                               onkeydown="keydownphoneuser(event)"
                                                               onkeyup="keyupphoneuser(event)"
                                                               class="input" type="text">
                                                        <div class="txt-input__required txt-input__required--error">Неверно указан номер телефона</div>
                                                    </div>
                                                </label>
                                            </div>
                                        </div>
                                        <div v-if="isTax" class="fast-pay-submit__caption ex-small">
                                            Внимание: при оплате услуг с использованием банковсвкой карты дополнительно взымается комиссия – 1% (один процент)
                                        </div>
                                    </div>

                                    <div class="fast-pay-submit__right-section">
                                        <div class="fast-pay-submit__row">
                                            <div class="line-form__double-btn-width line-form__double-btn-width--full-mobile line-form__double-btn-width--offset-left">
                                                <div class="txt-input__label" @click="viewAccount()">Сумма к оплате</div>
                                                <div class="payment-drop js-cards-container">
                                                    <button type="button" class="button button--with-arrow button--th-second payment-drop__toggle js-cards-toggle" data-toggle="dropdown">
                                                        <span v-if="bankId==''" class="filter-option pull-left">Способ оплаты</span>
                                                        <img v-if="bankId=='sbr'" class="payment-drop__icon" src="/images/pay-types/sberbank-icon.png" />
                                                        <span v-if="bankId=='sbr'" class="payment-drop__text">Сбербанк</span>
                                                        <img v-if="bankId=='gas'" class="payment-drop__icon" src="/images/pay-types/gasprombank-icon.png" />
                                                        <span v-if="bankId=='gas'" class="payment-drop__text">Газпромбанк</span>

                                                    </button>
                                                    <div class="payment-drop__drop">
                                                        <ul class="payment-drop__drop-inner">
                                                            <li class="payment-drop__item">
                                                                Оплатите картой любого банка
                                                            </li>
                                                            <li v-if="sumPay>0.0" class="payment-drop__divider"></li>
                                                            <li v-if="sumPay>0.0" class="payment-drop__item" @click="bank('gas')">
                                                                <div class="payment-drop__link js-cards-option">
                                                                    <img class="payment-drop__icon" src="/images/pay-types/gasprombank-icon.png" />
                                                                    <span class="payment-drop__text">Газпромбанк</span>
                                                                </div>
                                                            </li>

                                                            <li v-if="isSber && sumPay>0.0" class="payment-drop__divider"></li>
                                                            <li v-if="isSber && sumPay>0.0" class="payment-drop__item" @click="bank('sbr')">
                                                                <div class="payment-drop__link js-cards-option">
                                                                    <img class="payment-drop__icon" src="/images/pay-types/sberbank-icon.png" />
                                                                    <span class="payment-drop__text">Сбербанк</span>
                                                                </div>
                                                            </li>

                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <button type="button" v-bind:class="btPay" @click="Pay" data-submit>Оплатить&nbsp;<span class="js-price-container">{{visualSum}}</span>&nbsp;₽</button>
                                        </div>
                                        <div class="fast-pay-submit__agree">
                                            <div class="fast-pay-submit__line">
                                                <label class="cb-input">
                                                    <input v-model="isConfirm" class="cb-input__checkbox req" type="checkbox" data-type="checkbox">
                                                    <span class="cb-input__check"></span>
                                                    <span class="cb-input__label">Подтверждаю параметры платежа</span>
                                                </label>
                                            </div>
                                            <div class="fast-pay-submit__line">
                                                <label class="cb-input">
                                                    <input v-model="isAgree" class="cb-input__checkbox req" type="checkbox" data-type="checkbox">
                                                    <span class="cb-input__check"></span>
                                                    <span class="cb-input__label">С порядком и условиями оплаты, <br> <a href="/Site/UserAgreementUR" target="_blank" class="link link--underline"><span class="link__text">зачисления</span></a> и <a href="/Site/UserAgreement" target="_blank" class="link link--underline"><span class="link__text">возврата</span></a> денежных средств согласен.</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="catalog__info pay-info block">
                <div class="pay-info__ctrl">
                    <a href="#payInfoDetail" class="collapse-link link link--underline collapsed" data-toggle="collapse">
                        <span class="link__text h4 status-primary">Информация об оплате банковской картой</span>
                        <span class="link__icon fab-icon">
                            <i class="icon icon--angle-down"></i>
                        </span>
                    </a>
                </div>
                <div class="pay-info__types">
                    <div class="pay-info__item">
                        <img src="/images/pay-types/visa.png" alt="">
                    </div>
                    <div class="pay-info__item">
                        <img src="/images/pay-types/visa-verified.png" alt="">
                    </div>
                    <div class="pay-info__item">
                        <img src="/images/pay-types/mastercard.png" alt="">
                    </div>
                    <div class="pay-info__item">
                        <img src="/images/pay-types/mastercard-secure.png" alt="">
                    </div>
                    <div class="pay-info__item">
                        <img src="/images/pay-types/mir.png" alt="">
                    </div>
                    <div class="pay-info__item">
                        <img src="/images/pay-types/mir-acept.png" alt="">
                    </div>
                    <div class="pay-info__item">
                        <img src="/images/pay-types/unionPay.png" alt="">
                    </div>
                </div>
            </div>
            <div id="payInfoDetail" class="pay-info-body accordion-body collapse">
                <div class="accordion-body__inner block">
                    <div class="editor ex-small">
                        <h2>К оплате принимаются следующие типы банковских карт:</h2>

                        <ul class="list-divide">
                            <li>
                                <h3>VISA, имеющие трехзначный код CVV2;</h3>
                            </li>
                            <li>
                                <h3>Mastercard, имеющие трехзначный код CVС2;</h3>
                            </li>
                            <li>
                                <h3>МИР, имеющие трехзначный код на обратной стороне.</h3>
                            </li>
                        </ul>

                        <h5>В случае успешной авторизации Вы получите от сайта уведомление о том, что оплата проведена и/или описание порядка получения товара/услуги.</h5>

                        <p>В рамках технологии интернет-эквайринга возврат денежных средств возможен исключительно по реквизитам банковской карты с которой проводилась оплата.</p>
                        <p>Безопасность платежей обеспечивается с помощью Банка-эквайера (ГАЗПРОМБАНК (Акционерное Общество)), функционирующего на основе современных протоколов и технологий, разработанных платежными системами МИР, Visa International и Mastercard Worldwide (3D-Secure: Verified by VISA, Mastercard SecureCode, MirAccept).</p>
                        <p>Обработка полученных конфиденциальных данных Держателя карты производится в процессинговом центре Банка, сертифицированного по стандарту PCI DSS. Безопасность передаваемой информации обеспечивается с помощью современных протоколов обеспечения безопасности в сети Интернет.</p>
                        <p>При оплате данные Вашей пластиковой карты вводятся на платежной странице Банка с использованием защищенного канала. Информация передаётся в зашифрованном виде и обрабатывается только на специализированном сервере банка.</p>
                        <p>После нажатия кнопки «Оплатить» Вы будете направлены на защищенную платежную страницу процессингового центра Банка, где необходимо ввести данные пластиковой карты.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="page__aside block">
            <div class="aside">
                <div class="aside__item aside__item--divider">
                    <a href="" class="card-promo card-promo--hover card-promo--error card">
                        <div class="card-promo__bg"></div>
                        <div class="card-promo__head">
                            <div class="card-promo__title h2">Способы оплаты</div>
                            <div class="card-promo__icon">
                                <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 30a30 30 0 1 1 60 0 30 30 0 0 1-60 0zM30 1.94a28.06 28.06 0 0 0-19.72 48.02c.97-3.27 2.37-5.6 4.14-7.13a9.12 9.12 0 0 1 6.12-2.2h18.92c2.2 0 4.31.65 6.12 2.2 1.77 1.53 3.17 3.86 4.14 7.13A28.06 28.06 0 0 0 30 1.95zm0 56.12c-6.9 0-13.23-2.5-18.12-6.64l.24-.83c.9-3.07 2.15-5.06 3.57-6.28a7.17 7.17 0 0 1 4.85-1.73h18.92c1.8 0 3.44.52 4.85 1.73 1.42 1.22 2.67 3.2 3.57 6.28l.24.83A27.94 27.94 0 0 1 30 58.06zm0-43.55a9.68 9.68 0 1 0 0 19.37 9.68 9.68 0 0 0 0-19.37zm-7.74 9.68a7.74 7.74 0 1 1 15.48 0 7.74 7.74 0 0 1-15.48 0z" />
                                </svg>
                            </div>
                        </div>
                        <div class="card-promo__body">
                            <div class="card-promo__text">Здесь сможете узнать о методах оплаты, чтобы вы могли выбрать наиболее удобный для вас метод</div>
                        </div>
                        <div class="card-promo__footer">
                            <div class="more-link">
                                <span class="link__text">Подробнее</span>
                                <span class="more-link__icon fab-icon">
                                    <i class="icon icon--arrow-right"></i>
                                </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="aside__item aside__item--divider">
                    <a href="" class="card-promo card-promo--hover card-promo--error card">
                        <div class="card-promo__bg"></div>
                        <div class="card-promo__head">
                            <div class="card-promo__title h2">Реквизиты для оплаты</div>
                            <div class="card-promo__icon">
                                <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0 30a30 30 0 1 1 60 0 30 30 0 0 1-60 0zM30 1.94a28.06 28.06 0 0 0-19.72 48.02c.97-3.27 2.37-5.6 4.14-7.13a9.12 9.12 0 0 1 6.12-2.2h18.92c2.2 0 4.31.65 6.12 2.2 1.77 1.53 3.17 3.86 4.14 7.13A28.06 28.06 0 0 0 30 1.95zm0 56.12c-6.9 0-13.23-2.5-18.12-6.64l.24-.83c.9-3.07 2.15-5.06 3.57-6.28a7.17 7.17 0 0 1 4.85-1.73h18.92c1.8 0 3.44.52 4.85 1.73 1.42 1.22 2.67 3.2 3.57 6.28l.24.83A27.94 27.94 0 0 1 30 58.06zm0-43.55a9.68 9.68 0 1 0 0 19.37 9.68 9.68 0 0 0 0-19.37zm-7.74 9.68a7.74 7.74 0 1 1 15.48 0 7.74 7.74 0 0 1-15.48 0z" />
                                </svg>
                            </div>
                        </div>
                        <div class="card-promo__body">
                            <div class="card-promo__text">Здесь сможете найти всю необходимую информацию для осуществления платежей, включая реквизиты и другие данные</div>
                        </div>
                        <div class="card-promo__footer">
                            <div class="more-link">
                                <span class="link__text">Подробнее</span>
                                <span class="more-link__icon fab-icon">
                                    <i class="icon icon--arrow-right"></i>
                                </span>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    import Account from './account.vue';
    const classFind = 'button fast-pay-form__button button--th-ctrl js-form-payment';
    const classPay = 'button button--th-main line-form__double-btn-width line-form__double-btn-width--offset-left';// button button--th-main line-form__double-btn-width line-form__double-btn-width--offset-left
    const W13 = 12; // Отопление.
    const W99 = 3;  // Горячая вода.
    const W139 = 2; // ХВС.
    const W149 = 1; // Водоотведение.

    function GetIndex(type, sales) {
        for (var index in sales)
            if (type == sales[index].CategoryId)
                return index;
        return -1;
    }

    export default {
        components: {
            Account
        },
        props: ['cities', 'citiesfl', 'param'],
        data: function () {
            return {
                axiosConfig: null,
                Cities: [],
                cityId: Number,
                CitiesFl: [],
                cityIdx: Number,
                selectedCity: '',
                selectedCityFl: '',
                mask: /^$/,
                accInput: '',
                btClass: classFind + ' is-disable',
                btClassFl: classFind + ' is-disable',
                btPay: classPay + ' is-disable',
                listAcc: [],
                indexAcc: -1,
                sumPay: -1.0,
                isAgree: false,
                isConfirm: false,
                isSber: false,
                isFind: false,
                regexPhone: new RegExp("[+]|[ ]|[-]|[(-)]", 'g'),
                regexMail: new RegExp("^[a-z0-9!#$%&'*+=?^_`{|}~-]+(\.[a-z0-9!#$%&'*+=?^_`{|}~-]+)*@([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]([a-z0-9-]*[a-z0-9])?$"),
                phone: '',
                email: '',
                errorEmail: false,
                errorPhone: false,
                error: '',
                errFind: false,
                max: 15,
                isVisibleAcc: false,
                visualSum: '0,00',
                isSumPayVis: false,
                selectedStreetId: '',
                streetIdx: Number,
                selectedHouseId: '',
                selectedFlatId: '',
                bankId: '',
                isTax: false,
                isParam: false
            }
        },
        methods: {
            testEmail: function () {
                if (this.email != '' && !this.regexMail.test(this.email.toLowerCase())) {
                    this.errorEmail = true;
                    return false;
                }
                else
                    this.errorEmail = false;
                return true;
            },
            getHouses() {
                this.btClassFl = classFind + ' is-disable';
                this.selectedStreetId = $("#streets").val();
                var ctrl = $("#houses");
                ctrl.selectpicker({
                    noneResultsText: 'Не найдено {0}'
                });
                ctrl.empty();
                var o = $("<option disabled>нет домов для выбора</option>");
                o.appendTo(ctrl);
                ctrl.selectpicker("refresh");
                if ((this.selectedStreetId == undefined) || (this.selectedStreetId == '')) {
                    this.changeItemHouse();
                    return;
                }
                var url = '/Pay/GetHouses/' + this.selectedStreetId + '/' + this.selectedCityFl.BspId;
                var self = this;
                axios.get(url, this.axiosConfig)
                    .then(function (response) {
                        var houses = response.data;
                        ctrl.empty();
                        if ((houses.Error != undefined) || (houses.length == 0)) {
                            var o = $("<option value=''>нет домов для выбора</option>");
                            o.appendTo(ctrl);
                        }
                        else
                            for (var i = 0; i < houses.length; i++) {
                                var o = $("<option/>", { value: houses[i].split('|')[0], text: houses[i].split('|')[1] });
                                o.appendTo(ctrl);
                            }
                        ctrl.selectpicker("refresh");
                        self.changeItemHouse();
                    })
                    .catch(function (error) {
                        self.error = "Что-то пошло не так. Попробуйте позже.";
                        console.log('Ошибка получения домов:', error);
                    });
            },
            getFlats() {
                this.btClassFl = classFind + ' is-disable';
                this.selectedHouseId = $("#houses").val();
                var ctrl = $("#flats");
                ctrl.selectpicker({
                    noneResultsText: 'Не найдено {0}'
                });
                ctrl.empty();
                var o = $("<option disabled>нет квартир для выбора</option>");
                o.appendTo(ctrl);
                ctrl.selectpicker("refresh");
                if ((this.selectedHouseId == undefined) || (this.selectedHousetId == ''))
                    return;
                var url = '/Pay/GetFlats/' + this.selectedHouseId + '/' + this.selectedCityFl.BspId;
                var self = this;
                axios.get(url, this.axiosConfig)
                    .then(function (response) {
                        var flats = response.data;
                        ctrl.empty();
                        if ((flats.Error != undefined) || (flats.length == 0)) {
                            var o = $("<option value=''>нет квартир для выбора</option>");
                            o.appendTo(ctrl);
                        }
                        else
                            for (var i = 0; i < flats.length; i++) {
                                var o = $("<option/>", { value: flats[i].split('|')[0], text: flats[i].split('|')[1] });
                                o.appendTo(ctrl);
                            }
                        ctrl.selectpicker("refresh");
                        self.changeItemFlat();
                    })
                    .catch(function (error) {
                        self.error = "Что-то пошло не так. Попробуйте позже.";
                        console.log('Ошибка получения квартир:', error);
                    });
            },

            getAccountByAddr() {
                if (this.isFind) return;
                this.isFind = true;
                this.listAcc = [];
                this.isTax = false;
                this.error = '';
                var url = '/Pay/GetAccountsByAddr/' + this.selectedCityFl.BspId + "/" + this.selectedStreetId + "/" + this.selectedHouseId + '/' + this.selectedFlatId;
                var self = this;
                axios.get(url, this.axiosConfig)
                    .then(function (response) {
                        self.listAcc = response.data;
                        //del it
                        //self.listAcc.push(self.listAcc[0]);
                        //self.listAcc.push(self.listAcc[0]);
                        if (self.listAcc.length > 0) {
                            for (var index in self.listAcc) {
                                self.listAcc[index].isFl = true;
                                self.listAcc[index].AccountId = self.listAcc[index].uAccount;
                                self.listAcc[index].accountNumber = self.listAcc[index].faceNum;
                                self.listAcc[index].contragentShortName = self.listAcc[index].city + ', ' + self.listAcc[index].address;
                                self.listAcc[index].BspId = self.selectedCityFl.BspId;
                            }
                        }
                        else {
                            self.errFind = (self.listAcc.length == 0);
                            self.error = (self.errFind) ? "Лицевой счёт по адресу не найден." : "";
                        }
                        self.isFind = false;
                    })
                    .catch(function (error) {
                        self.error = "Что-то пошло не так. Попробуйте позже.";
                        console.log('Ошибка получения Счетов:', error);
                        self.isFind = false;
                    });
            },

            getAccountFl() {
                this.error = '';
                if (this.selectedCity.BspIds == null) return;
                var url = '/Pay/GetAccountsFl/' + this.selectedCity.BspIds + "/" + this.accInput + "/" + this.isParam;
                var self = this;
                axios.get(url, this.axiosConfig)
                    .then(function (response) {
                        var listAcc = response.data;
                        if (listAcc.length > 0) {
                            self.accInput = listAcc[0].faceNum;
                            self.isParam = false;
                            for (var idx in self.listAcc)
                                self.listAcc[idx].contragentShortName += ' (Юр. Лицо) ';
                            for (var index in listAcc) {
                                listAcc[index].isFl = true;
                                listAcc[index].AccountId = listAcc[index].uAccount;
                                listAcc[index].accountNumber = listAcc[index].faceNum;
                                listAcc[index].contragentShortName = listAcc[index].city + ', ' + listAcc[index].address;
                                listAcc[index].BspId = self.selectedCity.BspIds;
                                self.listAcc.push(listAcc[index]);
                            }
                        }
                        else {
                            self.errFind = (self.listAcc.length == 0);
                            self.error = (self.errFind) ? "Такой номер лицевого счёта в выбранном городе не найден." : "";
                        }
                        self.isFind = false;
                    })
                    .catch(function (error) {
                        self.error = "Что-то пошло не так. Попробуйте позже.";
                        console.log('Ошибка получения Счетов:', error);
                        self.isFind = false;
                    });
            },


            changeItemStreet: function changeItemStreet() {
                this.getHouses();
            },
            changeItemHouse: function changeItemHouse() {
                this.getFlats();
            },
            changeItemFlat: function changeItemFlat() {
                this.selectedFlatId = $("#flats").val();
                if ((this.selectedFlatId) && (this.selectedFlatId != ''))
                    this.btClassFl = classFind;
            },

            maxLen: function () {
                if (this.accInput.length > this.max) {
                    this.accInput = this.accInput.substr(0, this.max);
                }
            },
            Pay: function () {
                this.error = '';
                if (this.indexAcc < 0) this.error = 'Не выбран счёт.'
                this.errorEmail = false;
                this.errorPhone = false;
                if (this.sumPay == 0.0) {
                    this.error = 'Нет суммы для оплаты.'
                    return;
                }
                else
                    this.sumPay = Math.round(this.sumPay * 100) / 100;
                this.phone = document.getElementById("phone-user").value;
                if (this.phone.length < 4) this.phone = '';
                var no = this.phone.replaceAll(this.regexPhone, '');
                if (no.length > 11) no = no.substr(0, 11);
                if (this.email == '' && no == '') {
                    this.error = "Должен быть указан телефон или e-mail.";
                    return;
                }
                if (this.email != '' && !this.regexMail.test(this.email.toLowerCase())) this.errorEmail = true;
                if (no != '' && no.length != 11) this.errorPhone = true;
                if (this.errorEmail || this.errorPhone) return;

                this.btPay += ' is-disable'
                if (this.listAcc[this.indexAcc].isFl) {
                    this.recalcSum(this.sumPay);
                    this.PayFl(no);
                    return;
                }

                var acc = this.listAcc[this.indexAcc];
                let Sales = [];
                for (var index in acc.invoices) {
                    var id = acc.invoices[index].invoiceType.id;
                    if (id != -1) {
                        let sales = {};
                        sales.Amount = (acc.invoices[index].deptEnd < 0) ? 0.0 : acc.invoices[index].deptEnd;
                        sales.CategoryId = id;
                        Sales.push(sales);
                    }
                }
                let Account = {};
                Account.AccountId = acc.accountId;
                Account.AccountNumber = acc.accountNumber;
                Account.BillingSystem = acc.billingSystem;
                Account.DatabaseId = acc.contractOrder.databaseId;
                Account.DivisionId = acc.division.id;
                let Items = {};
                Items.Account = Account;
                Items.Sales = Sales;
                let payment = {};
                payment.Id = 0;
                payment.Email = this.email;
                payment.Items = Items;
                payment.Phone = no;
                payment.TotalAmount = acc.balans.balansSum;
                payment.TotalBalans = acc.balans.balansSum;
                payment.TotalAdvance = 0;
                payment.TotalFee = 0;
                payment.TotalPeny = 0;

                if (payment.TotalAmount != this.sumPay) {
                    // Распределение аванса.
                    var sumMain1 = 0.0;
                    var sumMain2 = 0.0;
                    var sumOther = 0.0;
                    var sumPay = this.sumPay;
                    for (var index in payment.Items.Sales) {
                        var type = payment.Items.Sales[index].CategoryId;
                        if (type == 1 || type == 12 || type == 60)      // В счетах САП основная реализация CategoryId=1 а не 12 !!!
                            sumMain1 += payment.Items.Sales[index].Amount;
                        else if (type == 56 || type == 57 || type == 109)
                            sumMain2 += payment.Items.Sales[index].Amount;
                        else
                            sumOther += payment.Items.Sales[index].Amount;
                    }

                    // Услуги первой очереди.
                    var sum = (sumPay < sumMain1) ? sumPay : sumMain1;
                    var index = GetIndex(12, payment.Items.Sales);
                    if (index > -1) payment.Items.Sales[index].Amount = sum;
                    else {
                        index = GetIndex(1, payment.Items.Sales);
                        if (index > -1) payment.Items.Sales[index].Amount = sum;
                        else
                            payment.Items.Sales[GetIndex(60, payment.Items.Sales)].Amount = sum;
                    }
                    sumPay -= sum;

                    // Услуги второй очереди.
                    if (sumMain2 > 0.0)
                        if (sumPay > 0.0) {
                            if (sumPay < sumMain2) {
                                index = GetIndex(56, payment.Items.Sales);
                                if (index > -1) {
                                    sum = payment.Items.Sales[index].Amount;
                                    sum = Math.round(sumPay * sum / sumMain2 * 100) / 100;
                                    payment.Items.Sales[index].Amount = sum;
                                    sumPay -= sum;
                                }
                                index = GetIndex(57, payment.Items.Sales);
                                if (index > -1) {
                                    sum = payment.Items.Sales[index].Amount;
                                    sum = Math.round(sumPay * sum / sumMain2 * 100) / 100;
                                    payment.Items.Sales[index].Amount = sum;
                                    sumPay -= sum;
                                }
                                index = GetIndex(109, payment.Items.Sales);
                                if (index > -1) {
                                    sum = payment.Items.Sales[index].Amount;
                                    sum = Math.round(sumPay * sum / sumMain2 * 100) / 100;
                                    payment.Items.Sales[index].Amount = sum;
                                    sumPay -= sum;
                                }
                            }
                            else {
                                index = GetIndex(56, payment.Items.Sales);
                                if (index > -1)
                                    sumPay -= payment.Items.Sales[index].Amount;
                                index = GetIndex(57, payment.Items.Sales);
                                if (index > -1)
                                    sumPay -= payment.Items.Sales[index].Amount;
                                index = GetIndex(109, payment.Items.Sales);
                                if (index > -1)
                                    sumPay -= payment.Items.Sales[index].Amount;
                            }
                        }
                        else
                            for (var index in payment.Items.Sales) {
                                var type = payment.Items.Sales[index].CategoryId;
                                if (type == 56 || type == 57 || type == 109)
                                    payment.Items.Sales[index].Amount = 0.0;
                            }

                    // Услуги третьей очереди (дополнительные).
                    if (sumOther > 0.0)
                        if (sumPay > 0.0) {
                            if (sumPay < sumOther)
                                for (var ix in payment.Items.Sales) {
                                    var type = payment.Items.Sales[ix].CategoryId;
                                    if (type != 12 && type != 60 && type != 56 && type != 57 && type != 109) {
                                        sum = payment.Items.Sales[ix].Amount;
                                        sum = Math.round(sumPay * sum / sumOther * 100) / 100;
                                        payment.Items.Sales[ix].Amount = sum;
                                        sumPay -= sum;
                                    }
                                }
                            else
                                for (var ix in payment.Items.Sales) {
                                    var type = payment.Items.Sales[ix].CategoryId;
                                    if (type != 12 && type != 60 && type != 56 && type != 57 && type != 109)
                                        sumPay -= payment.Items.Sales[ix].Amount;
                                }
                        }
                        else
                            for (var ix in payment.Items.Sales) {
                                var type = payment.Items.Sales[ix].CategoryId;
                                if (type != 12 && type != 60 && type != 56 && type != 57 && type != 109)
                                    payment.Items.Sales[ix].Amount = 0.0;
                            }

                    // Дораспределение остатка.
                    if (acc.legalAccountStatus == 4 && sumPay > 0.0) {
                        var index = GetIndex(12, payment.Items.Sales);
                        if (index > -1) payment.Items.Sales[index].Amount = Math.round((payment.Items.Sales[index].Amount + sumPay) * 100) / 100;
                        else {
                            index = GetIndex(1, payment.Items.Sales);
                            if (index > -1) payment.Items.Sales[index].Amount = Math.round((payment.Items.Sales[index].Amount + sumPay) * 100) / 100;
                            else
                                payment.Items.Sales[GetIndex(60, payment.Items.Sales)].Amount = Math.round((payment.Items.Sales[GetIndex(60, payment.Items.Sales)].Amount + sumPay) * 100) / 100;
                        }
                    }
                    else
                        this.sumPay -= sumPay;
                    payment.TotalAmount = this.sumPay;
                }

                // Установка cookie для выхода из учётки служебного пользователя после оплаты.
                var cookie_date = new Date();
                cookie_date.setDate(cookie_date.getDate() + 1);
                document.cookie = "quickpay=1; path=/;expires=" + cookie_date.toUTCString();

                var self = this;
                axios.get('/Pay/GetToken', this.axiosConfig)
                    .then(function (response) {
                        axios.post('/ul/payment/pay', payment, { headers: { "Authorization": "Bearer " + response.data } })
                            .then(function (response) {
                                var data = response.data;
                                if (data.success) window.location = data.targetUrl;
                                else
                                    console.log(response);
                                self.btPay = classPay;
                            })
                            .catch(function (error) {
                                self.error = "Что-то пошло не так. Попробуйте позже.";
                                console.log('Ошибка оплаты:', error);
                                self.btPay = classPay;
                            });
                    })
                    .catch(function (error) {
                        self.error = error;
                        self.btPay = classPay;
                        return;
                    });
                return true;
            },
            Find: function () {
                if (this.isFind) return;
                this.isFind = true;
                this.listAcc = [];
                this.isTax = false;
                this.error = '';
                this.sumPay = 0.0;
                var accountMask = new Object();
                accountMask.Div = this.selectedCity.DivisionIds;
                accountMask.Acc = this.accInput;
                accountMask.UserId = '';
                var self = this;
                axios.post('/Pay/FindAccounts', accountMask, this.axiosConfig)
                    .then(function (response) {
                        self.listAcc = response.data;
                        self.getAccountFl();
                        //self.errFind = (self.listAcc.length == 0);
                        //self.error = (self.errFind) ? "Такой номер лицевого счёта в выбранном городе не найден." : "";
                    })
                    .catch(function (error) {
                        console.log(error);
                        self.getAccountFl();
                    });

            },
            updateIndex: function (index) {
                this.bankId = '';
                this.indexAcc = index;
                if (this.listAcc[index].isFl) {
                    this.isTax = false;
                    this.isSber = this.listAcc[index].isSber;
                }
                else {
                    this.isTax = true;
                    this.isSber = false;
                }
                for (var idx in this.$refs.acc) {
                    if (this.indexAcc != idx)
                        this.$refs.acc[idx].ClearChecked();
                }
            },
            updateSum: function (sum) {
                this.visualSum = sum;
                this.sumPay = Number(sum.replaceAll(' ', '').replace(',', '.'));

            },
            bank: function (bnk) {
                this.bankId = bnk;
                this.btPay = classPay;
                if (!this.isAgree || !this.isConfirm || this.sumPay <= 0.0 || this.bankId.length == 0)
                    this.btPay += ' is-disable';
            },
            recalcSum: function (manSum) {
                manSum = Math.round(manSum * 100) / 100;
                var sumPay = 0.0;
                var isEditSum = false;
                var sumMainServOpen = 0.0;   // Сумма начислений по ОУ.
                var sumMainServClosed = 0.0; // Сумма начислений по ОУ.
                var sumAddServOpen = 0.0;    // Сумма начислений по ДУ.
                var sumAddServClosed = 0.0;  // Сумма начислений по ДУ.
                var sumWeightFactors = 0.0;  // Сумма весовых коэффициентов (только открытые счета).
                var nOpenProd = 0;           // Количество услуг в открытых счетах.

                //!!! Для отладки.
                //this.selectedAcc.forEach((this.listAcc[this.indexAcc]) => {
                //    if (this.listAcc[this.indexAcc].AccountNumber.indexOf('300') > 0)
                //        this.listAcc[this.indexAcc].TerminationDate = '2023-01-01'
                //});

                this.listAcc[this.indexAcc].prod.forEach((prod) => {
                    prod.ToPay = this.Debt(prod.saldo);
                    sumPay += prod.ToPay;
                    prod.open = (this.listAcc[this.indexAcc].status == '0')
                    nOpenProd += (prod.open) ? 1 : 0;
                    switch (prod.item) {
                        case 13:
                            if (prod.open) {
                                sumMainServOpen += this.Debt(prod.saldo);
                                sumWeightFactors += W13;
                            }
                            else
                                sumMainServClosed += this.Debt(prod.saldo);
                            break;
                        case 99:
                            if (prod.open) {
                                sumMainServOpen += this.Debt(prod.saldo);
                                sumWeightFactors += W99;
                            }
                            else
                                sumMainServClosed += this.Debt(prod.saldo);
                            break;
                        case 139:
                            if (prod.open) {
                                sumMainServOpen += this.Debt(prod.saldo);
                                sumWeightFactors += W139;
                            }
                            else
                                sumMainServClosed += this.Debt(prod.saldo);
                            break;
                        case 149:
                            if (prod.open) {
                                sumMainServOpen += this.Debt(prod.saldo);
                                sumWeightFactors += W149;
                            }
                            else
                                sumMainServClosed += this.Debt(prod.saldo);
                            break;
                        default:
                            if (prod.open)
                                sumAddServOpen += this.Debt(prod.saldo);
                            else
                                sumAddServClosed += this.Debt(prod.saldo);
                            break;
                    }
                });
                sumPay = Math.round(sumPay * 100) / 100;
                var difference = manSum - sumPay;
                this.listAcc[this.indexAcc].prod.forEach((prod) => {
                    prod.ToPay = 0.0;
                });

                // Нет открытых счетов или нет разницы.
                if ((difference == 0.0) || ((difference > 0.0) && (nOpenProd == 0))) {
                    this.listAcc[this.indexAcc].prod.forEach((prod) => {
                        prod.ToPay = this.Debt(prod.saldo);
                    });
                    manSum = sumPay;
                    // debug1(1);
                    return;
                }

                // Достаточно для оплаты всех услуг.
                if (difference > 0.0) {
                    this.listAcc[this.indexAcc].prod.forEach((prod) => {
                        prod.ToPay = this.Debt(prod.saldo);
                    });
                    this.listAcc[this.indexAcc].prod.forEach((prod) => {
                        var sum = 0.0;
                        if (prod.open) {
                            switch (prod.item) {
                                case 13:
                                    sum = difference / sumWeightFactors * W13;
                                    break;
                                case 99:
                                    sum = difference / sumWeightFactors * W99;
                                    break;
                                case 139:
                                    sum = difference / sumWeightFactors * W139;
                                    break;
                                case 149:
                                    sum = difference / sumWeightFactors * W149;
                                    break;
                            }
                            prod.ToPay += Math.floor(sum * 100) / 100;
                        }
                    });
                    // debug1(2);
                    // Распределение копеек.
                    var i = Math.round((manSum - this.recalcManSum()) * 100);
                    while (i > 0) {
                        if (i > 0) {
                            this.listAcc[this.indexAcc].prod.forEach((prod) => {
                                if ((prod.open) && (prod.item == 13)) {
                                    if (i-- > 0)
                                        prod.ToPay = Math.round((prod.ToPay + 0.01) * 100) / 100;
                                }
                            });
                            if (i > 0) {
                                this.listAcc[this.indexAcc].prod.forEach((prod) => {
                                    if ((prod.open) && (prod.item == 99)) {
                                        if (i-- > 0)
                                            prod.ToPay = Math.round((prod.ToPay + 0.01) * 100) / 100;
                                    }
                                });
                                if (i > 0) {
                                    this.listAcc[this.indexAcc].prod.forEach((prod) => {
                                        if ((prod.open) && (prod.item == 139)) {
                                            if (i-- > 0)
                                                prod.ToPay = Math.round((prod.ToPay + 0.01) * 100) / 100;
                                        }
                                    });
                                    if (i > 0) {
                                        this.listAcc[this.indexAcc].prod.forEach((prod) => {
                                            if ((prod.open) && (prod.item == 149)) {
                                                if (i-- > 0)
                                                    prod.ToPay = Math.round((prod.ToPay + 0.01) * 100) / 100;
                                            }
                                        });
                                    }
                                }
                            }
                        }
                    }
                    return;
                }

                // Все счета закрыты.
                if (nOpenProd == 0) {
                    // Недостаточно для оплаты всех услуг.
                    if (difference < 0.0) {
                        if (manSum < sumMainServClosed) { // Недостаточно для оплаты основных услуг.
                            this.listAcc[this.indexAcc].prod.forEach((prod) => {
                                if (((prod.item == 13) || (prod.item == 99) || (prod.item == 139) || (prod.item == 149)) && prod.saldo > 0.0) {
                                    var sum = this.Debt(prod.saldo) / sumMainServClosed * manSum;
                                    prod.ToPay += Math.floor(sum * 100) / 100;
                                }
                            });
                            // debug1(4);
                            // Распределение копеек.
                            var i = Math.round((manSum - this.recalcManSum()) * 100);
                            while (i > 0) {
                                if (i > 0) {
                                    this.listAcc[this.indexAcc].prod.forEach((prod) => {
                                        if ((prod.item == 13) && (prod.saldo > prod.ToPay)) {
                                            if (i-- > 0)
                                                prod.ToPay = Math.round((prod.ToPay + 0.01) * 100) / 100;
                                        }
                                    });
                                    if (i > 0) {
                                        this.listAcc[this.indexAcc].prod.forEach((prod) => {
                                            if ((prod.item == 99) && (prod.saldo > prod.ToPay)) {
                                                if (i-- > 0)
                                                    prod.ToPay = Math.round((prod.ToPay + 0.01) * 100) / 100;
                                            }
                                        });
                                        if (i > 0) {
                                            this.listAcc[this.indexAcc].prod.forEach((prod) => {
                                                if ((prod.item == 139) && (prod.saldo > prod.ToPay)) {
                                                    if (i-- > 0)
                                                        prod.ToPay = Math.round((prod.ToPay + 0.01) * 100) / 100;
                                                }
                                            });
                                            if (i > 0) {
                                                this.listAcc[this.indexAcc].prod.forEach((prod) => {
                                                    if ((prod.item == 149) && (prod.saldo > prod.ToPay)) {
                                                        if (i-- > 0)
                                                            prod.ToPay = Math.round((prod.ToPay + 0.01) * 100) / 100;
                                                    }
                                                });
                                            }
                                        }
                                    }
                                }
                            }
                            // debug1(5);
                            return;
                        }
                        else // Остались деньги после оплаты основных услуг.
                        {
                            this.listAcc[this.indexAcc].prod.forEach((prod) => {
                                if (((prod.item == 13) || (prod.item == 99) || (prod.item == 139) || (prod.item == 149)) && prod.saldo > 0.0) {
                                    prod.ToPay = prod.saldo;
                                    manSum -= prod.ToPay;
                                }
                            });
                            this.listAcc[this.indexAcc].prod.forEach((prod) => {
                                if ((prod.item != 13) && (prod.item != 99) && (prod.item != 139) && (prod.item != 149) && (prod.saldo > 0)) {
                                    var sum = prod.saldo / sumAddServClosed * manSum;
                                    prod.ToPay = Math.floor(sum * 100) / 100;
                                }
                            });
                            // debug1(6);
                            // Распределение копеек.
                            var i = Math.round((manSum - this.recalcManSum()) * 100);
                            while (i > 0) {
                                this.listAcc[this.indexAcc].prod.forEach((prod) => {
                                    if ((i > 0) && (prod.item != 13) && (prod.item != 99) && (prod.item != 139) && (prod.item != 149) && (prod.saldo > prod.ToPay)) {
                                        prod.ToPay = Math.round((prod.ToPay + 0.01) * 100) / 100;
                                        --i;
                                    }
                                });
                            }
                            // debug1(7);
                            return;
                        }
                    }
                }

                // Есть открытые счета. Недостаточно для оплаты всех услуг.
                if ((difference < 0.0) && (nOpenProd > 0)) {
                    var Sum = manSum;
                    if (manSum <= (sumMainServClosed + sumMainServOpen)) { // Недостаточно для оплаты основных услуг.
                        // Распределение по ОУ закрытых счетов.
                        this.listAcc[this.indexAcc].prod.forEach((prod) => {
                            if (!prod.open) {
                                var sum = 0.0;
                                switch (prod.item) {
                                    case 13:
                                        sum = manSum / sumWeightFactors * W13;
                                        break;
                                    case 99:
                                        sum = manSum / sumWeightFactors * W99;
                                        break;
                                    case 139:
                                        sum = manSum / sumWeightFactors * W139;
                                        break;
                                    case 149:
                                        sum = manSum / sumWeightFactors * W149;
                                        break;
                                }
                                sum = Math.floor(sum * 100) / 100;
                                if (sum <= prod.saldo) {
                                    prod.ToPay = sum;
                                    Sum -= sum;
                                }
                                else {
                                    prod.ToPay = this.Debt(prod.saldo);
                                    Sum -= this.Debt(prod.saldo);
                                }
                            }
                        });
                        // debug1(8);
                        // Распределение по ОУ открытых счетов.
                        this.listAcc[this.indexAcc].prod.forEach((prod) => {
                            if (prod.open) {
                                var sum = 0.0;
                                switch (prod.item) {
                                    case 13:
                                        sum = Sum / sumWeightFactors * W13;
                                        break;
                                    case 99:
                                        sum = Sum / sumWeightFactors * W99;
                                        break;
                                    case 139:
                                        sum = Sum / sumWeightFactors * W139;
                                        break;
                                    case 149:
                                        sum = Sum / sumWeightFactors * W149;
                                        break;
                                }
                                prod.ToPay += Math.floor(sum * 100) / 100;
                            }
                        });
                        // debug1(9);
                        // Распределение копеек.
                        var i = Math.round((manSum - this.recalcManSum()) * 100);
                        while (i > 0) {
                            if (i > 0) {
                                this.listAcc[this.indexAcc].prod.forEach((prod) => {
                                    if ((prod.item == 13) && (prod.open || (prod.saldo > prod.ToPay))) {
                                        if (i-- > 0)
                                            prod.ToPay = Math.round((prod.ToPay + 0.01) * 100) / 100;
                                    }
                                });
                                if (i > 0) {
                                    this.listAcc[this.indexAcc].prod.forEach((prod) => {
                                        if ((prod.item == 99) && (prod.open || (prod.saldo > prod.ToPay))) {
                                            if (i-- > 0)
                                                prod.ToPay = Math.round((prod.ToPay + 0.01) * 100) / 100;
                                        }
                                    });
                                    if (i > 0) {
                                        this.listAcc[this.indexAcc].prod.forEach((prod) => {
                                            if ((prod.item == 139) && (prod.open || (prod.saldo > prod.ToPay))) {
                                                if (i-- > 0)
                                                    prod.ToPay = Math.round((prod.ToPay + 0.01) * 100) / 100;
                                            }
                                        });
                                        if (i > 0) {
                                            this.listAcc[this.indexAcc].prod.forEach((prod) => {
                                                if ((prod.item == 149) && (prod.open || (prod.saldo > prod.ToPay))) {
                                                    if (i-- > 0)
                                                        prod.ToPay = Math.round((prod.ToPay + 0.01) * 100) / 100;
                                                }
                                            });
                                        }
                                    }
                                }
                            }
                        }
                        // debug1(10);
                        return;
                    }
                    else // Остались деньги после оплаты основных услуг.
                    {
                        var Sum = manSum;
                        this.listAcc[this.indexAcc].prod.forEach((prod) => {
                            if (((prod.item == 13) || (prod.item == 99) || (prod.item == 139) || (prod.item == 149)) && prod.saldo > 0.0) {
                                prod.ToPay = prod.saldo;
                                Sum -= prod.ToPay;
                            }
                        });
                        var sumAddClosed = 0.0;
                        this.listAcc[this.indexAcc].prod.forEach((prod) => {
                            if ((!prod.open) && (prod.item != 13) && (prod.item != 99) && (prod.item != 139) && (prod.item != 149) && (prod.saldo > 0)) {
                                if (sumAddServClosed > 0.0) {
                                    var sum = prod.saldo / sumAddServClosed * Sum;
                                    prod.ToPay = Math.floor(sum * 100) / 100;
                                    if (prod.ToPay > prod.saldo) {
                                        sumAddClosed += prod.saldo;
                                        prod.ToPay = prod.saldo
                                    }
                                    else
                                        sumAddClosed += prod.ToPay;
                                }
                            }
                        });
                        Sum -= sumAddClosed;
                        this.listAcc[this.indexAcc].prod.forEach((prod) => {
                            if ((prod.open) && (prod.item != 13) && (prod.item != 99) && (prod.item != 139) && (prod.item != 149) && (prod.saldo > 0)) {
                                if (sumAddServOpen > 0.0) {
                                    var sum = prod.saldo / sumAddServOpen * Sum;
                                    prod.ToPay = Math.floor(sum * 100) / 100;
                                }
                            }
                        });
                        // debug1(11);
                        // Распределение копеек.
                        var i = Math.round((manSum - this.recalcManSum()) * 100);
                        console.log(i, manSum, this.recalcManSum());
                        while (i > 0) {
                            this.listAcc[this.indexAcc].prod.forEach((prod) => {
                                if ((i > 0) && (prod.item != 13) && (prod.item != 99) && (prod.item != 139) && (prod.item != 149) && (prod.open || (prod.saldo > prod.ToPay))) {
                                    prod.ToPay = Math.round((prod.ToPay + 0.01) * 100) / 100;
                                    --i;
                                }
                            });
                        }
                        // debug1(12);
                        return;
                    }
                }
            },
            myDebug: function (manSum) {
                var sum = 0.0;
                var accNum = this.listAcc[this.indexAcc].accountNumber;
                this.listAcc[this.indexAcc].prod.forEach((prod) => {
                    prod.ToPay = Math.round(prod.ToPay * 100) / 100;
                    console.log('Счет', accNum, prod.itemName, prod.item, 'SaldoEnd', prod.saldo, 'К оплате', prod.ToPay);
                    sum += prod.ToPay;
                });
                console.log('Введено:', manSum, ' Сумма по услугам:', Math.round(sum * 100) / 100, '  ', this.recalcManSum());
            },

            Debt: function (saldo) {
                saldo = Number(saldo);
                return (Number(saldo) > 0.0) ? Number(saldo) : 0.0;
            },
            recalcManSum: function () {
                var manSum = 0.0;
                this.listAcc[this.indexAcc].prod.forEach((prod) => {
                    prod.ToPay = Math.round(prod.ToPay * 100) / 100;
                    manSum += prod.ToPay;
                });
                return Math.round(manSum * 100) / 100;
            },
            viewAccount: function () {
                if (this.listAcc[this.indexAcc].isFl) {
                    this.recalcSum(this.sumPay);
                    this.myDebug(this.sumPay);
                }
                else
                    console.log("Только для ФЛ");
            },
            PayFl: function (phone) {
                var account = this.listAcc[this.indexAcc];
                let order = {};
                order.BSPID = account.BspId;
                order.Email = this.email;
                order.Phone = phone;
                order.UserId = "";
                order.Items = [];
                order.SupplierId = account.supplierId; // Для оплаты Сбер.
                for (var index in account.prod) {
                    let prod = {};
                    prod.Sum = account.prod[index].ToPay;
                    if (prod.Sum > 0.0) {
                        prod.ContractId = account.prod[index].contractId;
                        prod.Item = account.prod[index].item;
                        prod.Saldo = account.prod[index].saldo;
                        order.Items.push(prod);
                    }
                }
                if (order.Items.length == 0) return;
                var cookie_date = new Date();
                cookie_date.setDate(cookie_date.getDate() + 1);
                document.cookie = "quickpay=1; path=/;expires=" + cookie_date.toUTCString();
                var self = this;

                axios.get('/Pay/GetToken', this.axiosConfig)
                    .then(function (response) {
                        axios.post('/Profiles/Pay/' + (self.bankId == 'sbr'), order)
                            .then(function (response) {
                                var data = response.data;
                                if (data.error)
                                    alert(data.error);
                                else
                                    window.location = data.uri;
                                self.btPay = classPay;
                            })
                            .catch(function (error) {
                                alert(error);
                                //console.log(error);
                                self.btPay = classPay;
                            });
                    })
                    .catch(function (error) {
                        alert(error);
                        //console.log(error);
                        self.btPay = classPay;
                        return;
                    });
                return true;
            }
        },
        watch: {
            cityId: function (newId) {
                this.isVisibleAcc = true;
                for (var index in this.Cities)
                    if (this.Cities[index].Id == newId) {
                        this.selectedCity = this.Cities[index];
                        this.mask = new RegExp(this.selectedCity.MaskUl.split('||')[0]);
                        this.max = Number(this.selectedCity.MaskUl.split('||')[1]);
                        break;
                    }
                this.maxLen();
                this.btClass = classFind;
                if (!this.mask.test(this.accInput))
                    this.btClass += ' is-disable';
            },
            cityIdx: function (newIdx) {
                this.btClassFl = classFind + ' is-disable';
                this.selectedCityFl = this.CitiesFl[newIdx];
                var self = this;
                var ctrl = $("#streets");
                ctrl.selectpicker({
                    noneResultsText: 'Не найдено {0}'
                });
                ctrl.empty();
                var o = $("<option disabled>выберите улицу</option>");
                o.appendTo(ctrl);
                ctrl.selectpicker("refresh");
                var url = '/Pay/GetStreets/' + this.selectedCityFl.Id + '/' + this.selectedCityFl.BspId;
                axios.get(url, this.axiosConfig)
                    .then(function (response) {
                        var streets = response.data;
                        ctrl.empty();
                        if ((streets.Error != undefined) || (streets.length == 0)) {
                            var o = $("<option value=''>нет улиц для выбора</option>");
                            o.appendTo(ctrl);
                        }
                        else
                            for (var i = 0; i < streets.length; i++) {
                                var o = $("<option/>", { value: streets[i].split('|')[0], text: streets[i].split('|')[1] });
                                o.appendTo(ctrl);
                            }
                        ctrl.selectpicker("refresh");
                        self.changeItemStreet();
                    })
                    .catch(function (error) {
                        self.error = "Что-то пошло не так. Попробуйте позже.";
                        console.log('Ошибка получения улиц:', error);
                    });
            },
            accInput: function (newAcc) {
                this.btClass = classFind;
                if (!this.mask.test(newAcc))
                    this.btClass += ' is-disable';
            },
            isAgree: function (newCheck) {
                this.btPay = classPay;
                if (!newCheck || !this.isConfirm || this.sumPay <= 0.0 || this.bankId.length == 0)
                    this.btPay += ' is-disable';
            },
            isConfirm: function (newCheck) {
                this.btPay = classPay;
                if (!this.isAgree || !newCheck || this.sumPay <= 0.0 || this.bankId.length == 0)
                    this.btPay += ' is-disable';
            }
        },
        mounted() {
            this.Cities = JSON.parse(this.cities);
            this.CitiesFl = JSON.parse(this.citiesfl);
            if (this.param != "null") {
                this.isVisibleAcc = true;
                this.isParam = true;
                var param = JSON.parse(this.param)
                for (var index in this.Cities)
                    if (param.shortName == this.Cities[index].ShortName) {
                        this.selectedCity = this.Cities[index];
                        this.mask = new RegExp(this.selectedCity.MaskUl.split('||')[0]);
                        this.max = Number(this.selectedCity.MaskUl.split('||')[1]);
                        this.accInput = param.accountNumber;
                        break;
                    }
            }
            this.$nextTick(function () {
                var tvalue = $('input[name="__RequestVerificationToken"]').val();
                this.axiosConfig = {
                    headers: { 'RequestVerificationToken': tvalue }
                };
                if (this.isParam)
                    this.Find();
            });
        }
    }
</script>


// WEBPACK FOOTER //
// Scripts/app/pay/quickpay.vue